export default (value: any, usTariff?: boolean) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }
  if (typeof value === "string") value = value.trim();
  if (value === "") return true;
  if (usTariff) {
    return /(?!.*\.\.)(?!.*\-\-)(?!.*\/\/)(?!.*\s\s)^[+]?([\d|\.|\(|\)|\-]){5,20}\d$/gim.test(
      value
    );
  }
  return /(?!.*\.\.)(?!.*\-\-)(?!.*\/\/)(?!.*\s\s)^[+]?([\d|\.|\s|\-|\/]){5,20}\d$/gim.test(
    value
  );
};
